import React from 'react'

const WrapperPage = ({ children }) => {
  return <div className="wrapper-page">{children}</div>
}

export default WrapperPage
